$(document).ready(function () {
    $('.statistics-item').each(function () {
        var currentItem = $(this);
        var statisticsButton = currentItem.children('.statisticsButton');
        var statisticsModal = currentItem.children('.statisticsModal');

        statisticsButton.click(function (event) {
            var isExpanded = $(this).attr('aria-expanded') === 'true';
            var buttonRect = $(this)[0].getBoundingClientRect();
            var viewportHeight = $(window).height();
            var viewportWidth = $(window).width();
            var itemHeight = statisticsModal.height(); // Get the height of the statistics-item
            var itemTop = itemHeight / 2; 

            // Check if the trigger button is in the bottom 400px of the viewport
            if ((viewportHeight - buttonRect.bottom) < 300) {
                statisticsModal.css('transform', `translateY(-${itemHeight}px)`);
                statisticsModal.addClass('__top');
            } else {
                statisticsModal.removeClass('__top');
            }

            // Check if the trigger button is within 300px of the left side of the viewport
            if ((buttonRect.left < 300 && (viewportWidth >= 576)))  {
                statisticsModal.css('transform', `translateY(-${itemTop}px)`);
                statisticsModal.addClass('__left');
            } else {
                statisticsModal.removeClass('__left');
            }

            // Check if the trigger button is within 300px of the right side of the viewport
            if (((viewportWidth - buttonRect.right) < 300)) {
                statisticsModal.css('transform', `translateY(-${itemTop}px)`);
                statisticsModal.addClass('__right');
            }
            else {
                statisticsModal.removeClass('__right');
            }

            if (!isExpanded) {
                statisticsModal.show();
                $(this).attr('aria-expanded', true);
                currentItem.addClass('__modal-active').siblings('.statistics-item').removeClass('__modal-active')
                    .find('.statisticsButton').attr('aria-expanded', false)
                    .siblings('.statisticsModal').hide();
            } else {
                statisticsModal.hide();
                $(this).attr('aria-expanded', false);
                currentItem.removeClass('__modal-active');
            }
        });
    });
});
